// removed by extract-text-webpack-plugin
module.exports = {"Container":"SideDrawerItem__Container__241jv","IconContainer":"SideDrawerItem__IconContainer__286pf","Text":"SideDrawerItem__Text__2nGDa","Icon":"SideDrawerItem__Icon__ReeyU"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Lists/SideDrawerList/SideDrawerItem.css
// module id = 6146
// module chunks = 0